export default function RecommendedSection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-7xl mx-auto space-y-24">
          {/* おすすめの方、向いている人 */}
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                おすすめの方、向いている人
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  まごころヘルパーでは、「ご高齢者のために」「介護のために」という気持ちを強く持っている方にぜひ入職してほしいと考えています。より多くの利用者さまをサポートする立場を目指して、意欲的にキャリアやスキルを上げていける方に最適な職場です。また、利用者さまを大切に想える方と一緒に働きたいですね。利用者さまにとって、職員一人ひとりの存在が大きいと感じています。「多くいる利用者さまの1人」と思うのではなく、「掛け替えのない1人」という認識を持って、接することができる方に働いてほしいです。
                </p>
              </div>
            </div>

            <div className="h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/a27d47adc1c3b520a682e26ef473b6ea.jpg"
                alt="おすすめの方、向いている人"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* この仕事への思い */}
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="h-[500px] rounded-3xl overflow-hidden shadow-2xl order-2 lg:order-1">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Japanese%20home%20care%20worker%20speaking%20with%20confidence%20and%20passion%20about%20their%20work%20in%20a%20bright%20Japanese%20home%20setting.%20The%20person%20appears%20motivated%20and%20forward-thinking%20showing%20dedication%20to%20their%20career.%20Natural%20lighting%20with%20warm%20atmosphere.%20Photorealistic%20style%20capturing%20the%20professional%20growth%20mindset%20and%20commitment%20in%20home%20care%20profession&width=800&height=900&seq=recruit-passion-dedication-growth&orientation=portrait"
                alt="この仕事への思い"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="space-y-8 order-1 lg:order-2">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                この仕事への思い
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  まごころヘルパーが成長していくためには、職員一人ひとりのステップアップが欠かせないと感じています。「1年後も、職員皆が今と同じレベル」という状況では成長できません。職員それぞれが、サービス提供責任者や管理者といったキャリアアップを目指すことが大切です。1人の訪問ヘルパーとして関われるのは10名ほどかもしれません。しかし、事業所のトップになった場合、50名や100名といった数の利用者さまの生活を支えることになります。結果として、より多くの方の力になり、当事業所の成長につながると思いますよ。
                </p>
              </div>
            </div>
          </div>

          {/* 今後の展望 */}
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                今後の展望
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  今後の展望としては、事業拡大です。事業所の規模が大きくなれば、利用者さまの数を増やすことができ、職員皆の給料アップにもつながるはずです。また、職員のなかには「訪問ヘルパーとして、現場で活躍したい」という気持ちを大事にしている者もいます。職員の考えを尊重したうえで、ステップアップを目指せる環境を整えていきたいですね。
                </p>
              </div>
            </div>

            <div className="h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20group%20of%20Japanese%20home%20care%20workers%20having%20a%20friendly%20team%20discussion%20in%20a%20bright%20Japanese%20office%20or%20meeting%20space.%20They%20appear%20collaborative%20and%20supportive%20of%20each%20other%20showing%20teamwork.%20Natural%20lighting%20with%20positive%20atmosphere.%20Photorealistic%20style%20capturing%20the%20team%20spirit%20and%20future%20growth%20vision%20in%20home%20care%20organization&width=800&height=900&seq=recruit-team-future-vision-growth&orientation=portrait"
                alt="今後の展望"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
